import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DocumentNarrative } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class DocumentNarrativeService extends TmsWebBaseEditCreateService<DocumentNarrative, DocumentNarrative> {
  constructor() {
    super('DocumentNarrative', $localize`Document Narrative`);
  }
  getDocumentsForNarrative(narrativeId: string): Observable<DocumentNarrative[]> {
    return this.httpService.get<DocumentNarrative[]>(
      `${this.apiUrl}/GetDocumentsForNarrative?narrativeId=${narrativeId}`,
    );
  }

  updateNarrativeDocuments(
    narrativeId: string,
    documentIds: string[],
    printOnAllDocuments: boolean[],
  ): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/UpdateNarrativeDocuments`, {
      narrativeId,
      documentIds,
      printOnAllDocuments,
    });
  }
}
